<template>
    <v-container id="DetalleReporte" style="padding-top: 80px !important" class="pt-5">
        <div v-if="showcargando" id="cargando" style="z-index: 600;" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary" @click="mostrarDefiniciones()" style="cursor: pointer;">
                <p style="color: white;">Definición</p>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
                <iframe id="powerBI" runat="server" :src='this.ruta' height="315" class="iframePBI"></iframe>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import { mapMutations, mapState } from "vuex";
import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
import Indicadores from "@/services/Operacion/Indicadores.service.js";

    export default {
        title() {
            return this.$route.meta.title
        },
    components: {
        Menu
    },
    data() {
        return {
            showcargando: true,
            permisoIndicadores: false,
            ruta: '',
            mostrarPBI: true,
        }
    },
    computed: {
        ...mapState(["domain", "informationPage", "permission"]),
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        mostrarDefiniciones() {
            this.$router.push({ name: 'IndicadoresDefinicionDiario' });
        }
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '143').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 143)//Permiso para entrar a indicadores
                        this.permisoIndicadores = true;
                });
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
    async mounted() {
        this.changeReporteMenuOption('NoView');
        var formData = new FormData();
        formData.append("tipo", 22);
        let respuesta = await Indicadores.ObtenerParametro(formData);
        this.ruta = respuesta.pavalor
        this.showcargando = false;

    }
}
</script>

<style>
.iframePBI {
    width: 100%;
    height: 80vh;
}
</style>

